import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '../components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import { Button } from '../components/ui/button';
import { Package, Truck, Plus, Edit, Trash, ChevronDown, ChevronRight, FileDown } from 'lucide-react';
import Topbar from '../components/Topbar';
import Sidebar from '../components/Sidebar'; // Importa el Sidebar
import { toast, ToastContainer } from 'react-toastify'; // Importa el toast 
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'; // Importa axios 
import EditOrderModal from '../components/EditOrderModal';
import NewOrderModal from '../components/ModalNewOrder';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as XLSX from 'xlsx'; // Importación de la librería xlsx
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, TextField, Stack, Box } from '@mui/material';
import { 
  getOrders, 
  createOrder, 
  updateOrder, 
  deleteOrder, 
  getWarehouses, 
  getProducts, 
  getAccounts, 
  getClientLocations 
} from '../api';
import { useAuth } from '../contexts/AuthContext'; // Importación del contexto de autenticación
import Pagination from '@mui/material/Pagination';

const filterStyle = {
  backgroundColor: 'white',
  borderRadius: '4px',
  border: '1px solid #d1d5db',
  minWidth: '180px',
  height: '38px',
  '&:hover': {
    borderColor: '#9ca3af',
  },
};

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [bodegas, setBodegas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [clients, setClients] = useState([]);
  const [Cuentas, setCuentas] =useState ([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedwarehouseLocations, setSelectedwarehouseLocations] = useState([]);
  const [selectedwarehouse, setSelectedwarehouse] = useState(null);
  const [cuentaSeleccionada,setCuentaSeleccionada] =useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [orderProducts, setOrderProducts] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalNewOrderOpen, setIsModalNewOrderOpen] = useState(false);
  const [formData, setFormData] = useState({
    Order_number: '',
    Customer_PO: '',
    customer: '',
    address: '',
    City: '',
    State: '',
    Product_ID: '',
    Product_Qt: '',
    Appointment: '',
    Appointment_hr: '',
    Origin: '',
    cuenta: '',
    OrderStatus: 'CREATED',
    Created_dt: new Date().toISOString(),
    D_R: false, // Add D_R field with default value false (Delivery)
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('Órdenes');
  const [filter, setFilter] = useState({
    orderNumber: '',
    appointmentRange: [null, null], // Modificado: ahora es un rango [fecha inicio, fecha fin]
    customer: '',
    cuentas: [],
    statuses: [], // Cambiar de status (string) a statuses (array)
  });
  const [expandedOrders, setExpandedOrders] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [activeStatusCard, setActiveStatusCard] = useState(null);
  const { userRole } = useAuth(); // Obtener el rol del usuario usando el hook useAuth

  const orderStatuses = [...new Set(orders.map(order => order.Order_status))];

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  // Fetch orders on component mount
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await getOrders();
        setOrders(data);
      } catch (error) {
        console.error('Error fetching orders:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const data = await getOrders();
      setOrders(data);
    } catch (error) {
      console.error('Error fetching orders:', error);
      toast.error('Error fetching orders');
    }
  };

  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const data = await getWarehouses();
        setBodegas(data);
      } catch (error) {
        console.error('Error fetching warehouse:', error);
      }
    };
    fetchWarehouse();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProducts();
        setProducts(data);
      } catch (error) {
        console.error('Error fetching Products:', error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(()=> {
    const fetchCuentas = async () => {
      try {
        const data = await getAccounts();
        setCuentas(data);
      } catch (error) {
        console.error('Error fetching cuentas', error);
      }
    };
    fetchCuentas();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const data = await getClientLocations();
        
        if (!data || data.length === 0) {
          console.error('No client data received');
          return;
        }

        const uniqueClients = data.reduce((acc, client) => {
          const existingClient = acc.find(item => item.customer === client.customer);
          if (existingClient) {
            existingClient.locations.push({
              address: client.address,
              city: client.City,
              state: client.State,
            });
          } else {
            acc.push({
              customer: client.customer,
              locations: [{
                address: client.address,
                city: client.City,
                state: client.State,
              }],
            });
          }
          return acc;
        }, []);

        setClients(uniqueClients);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };
    fetchClients();
  }, []);

  const handleEdit = (id) => {
    const orderToEdit = orders.find(order => order.id === id);
    if (orderToEdit) {
      console.log("Editing order:", orderToEdit);
      
      // Asegurarse de que todos los campos necesarios estén presentes
      setEditFormData({
        ...orderToEdit,
        Appointment: orderToEdit.Appointment?.split('T')[0] || '', // Formatear fecha
        Origin: orderToEdit.Origin || '',
        address: orderToEdit.address || '',
        City: orderToEdit.City || '',
        State: orderToEdit.State || '',
        // Important: Ensure cuenta_id is passed to the edit modal
        cuenta_id: orderToEdit.cuenta_id || '',
      });
      
      // Si hay un cliente, encontrar sus ubicaciones
      if (orderToEdit.customer) {
        const selectedClient = clients.find(client => client.customer === orderToEdit.customer);
        if (selectedClient) {
          setSelectedClientLocations(selectedClient.locations || []);
        }
      }

      // Inicializar los productos de la orden
      setOrderProducts(orderToEdit.productos || []);
      
      setIsEditModalOpen(true);
    }
  };

  const handleEditSubmit = async (e, customFormData = null) => {
    e.preventDefault();
    try {
      // Use customFormData if provided (for special cases like special orders)
      const dataToSend = customFormData || {
        ...editFormData,
        productos: orderProducts
      };
      
      console.log('Updating order with data:', dataToSend);

      const updatedOrder = await updateOrder(editFormData.id, dataToSend);
      
      // Update orders list with new data
      const updatedOrders = orders.map(order => 
        order.id === editFormData.id ? updatedOrder : order
      );
      setOrders(updatedOrders);
      
      // Close modal and show success message
      setIsEditModalOpen(false);
      toast.success('Orden actualizada exitosamente');
      
      // Reload orders
      fetchOrders();
    } catch (error) {
      console.error('Error updating order:', error);
      toast.error('Error al actualizar la orden');
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClientChange = (event, value) => {
    if (value) {
      setSelectedClient(value);
      setFormData((prev) => ({
        ...prev,
        customer: value.customer,
      }));
      const filteredLocations = clients.find(client => client.customer === value.customer);
      setSelectedClientLocations(filteredLocations ? filteredLocations.locations : []);
    } else {
      setSelectedClientLocations([]);
    }
  };

  const handleProductChange = (index, value, field = 'product_id') => {
    setOrderProducts(prevProducts => {
      const updatedProducts = [...prevProducts];
      // Si no existe el producto en el índice, crear uno nuevo
      if (!updatedProducts[index]) {
        updatedProducts[index] = {
          product_id: null,
          product_qt: 0
        };
      }

      // Actualizar el campo correspondiente
      if (field === 'product_qt') {
        updatedProducts[index].product_qt = parseInt(value) || 0;
      } else if (value?.id) {
        updatedProducts[index].product_id = value.id;
      }

      return updatedProducts;
    });
  };

  const handleAddProduct = () => {
    setOrderProducts(prev => [
      ...prev,
      {
        product_id: null,
        product_qt: 0
      }
    ]);
  };

  const handleRemoveProduct = (index) => {
    setOrderProducts(orderProducts.filter((_, i) => i !== index));
  };

  const handleBodegaChange = (event, value) => {
    if (value) {
      setSelectedwarehouse(value);
      setFormData((prev) => ({
        ...prev,
        Origin: value.nombre,
      }));
      const filteredLocations = bodegas.find(bodega => bodega.nombre === value.nombre);
      setSelectedwarehouseLocations(filteredLocations ? filteredLocations.locations : []);
    } else {
      setSelectedwarehouseLocations([]);
    }
  };

  const handleCuentaChange = (event, value) => {
    if (value) {
        console.log("Cuenta seleccionada:", value);
        setCuentaSeleccionada(value); // Suponiendo que tienes un estado para almacenar la cuenta
        setFormData((prev) => ({
          ...prev,
          cuenta: value.nombre,
        }))
    } else {
        console.log("No se seleccionó ninguna cuenta");
        setCuentaSeleccionada(null);
    }
};

  const handleLocationChange = (event, value) => {
    if (value) {
      const { address, city, state } = value;
      setFormData((prev) => ({
        ...prev,
        address: address || '',
        City: city || '',
        State: state || '',
      }));
    }
  };

  const handleDeleteOrder = async (orderId) => {
    try {
      await deleteOrder(orderId);
      toast.success('Orden eliminada correctamente');
      
      // Reload orders
      fetchOrders();
    } catch (error) {
      console.error('Error deleting order:', error);
      toast.error('Error deleting order');
    }
  };

  const confirmDeleteOrder = (orderId) => {
    toast.info(
      <div>
        <p>¿Estás seguro de que deseas eliminar esta orden?</p>
        <div className="flex gap-2 mt-2">
          <Button
            className="p-1 bg-red-500 text-white rounded-md"
            onClick={async () => {
              await handleDeleteOrder(orderId);
              toast.dismiss();
            }}
          >
            Sí, eliminar
          </Button>
          <Button
            className="p-1 bg-gray-500 text-white rounded-md"
            onClick={() => toast.dismiss()}
          >
            Cancelar
          </Button>
        </div>
      </div>,
      {
        autoClose: false,
        closeButton: false,
      }
    );
  };

  const handleCreateOrder = async (e, customFormData = null) => {
    e.preventDefault();

    // Use customFormData if provided (for pickups), otherwise use regular formData
    const dataToUse = customFormData || formData;

    if (!dataToUse.Order_number || !dataToUse.address || !dataToUse.City ) {
      alert('Por favor, complete todos los campos obligatorios.');
      return;
    }

    try {
      const newOrder = {
        ...dataToUse,
        Created_dt: new Date().toISOString(),
        OrderStatus: 'CREATED',
        productos: orderProducts,
      };
      console.log('Datos enviados a la API:', newOrder);

      const response = await createOrder(newOrder);
      console.log('Respuesta de la API:', response);

      setOrders((prev) => [...prev, response]);
      setIsModalNewOrderOpen(false);

      setFormData({
        Order_number: '',
        cuenta:'',
        Customer_PO: '',
        customer: '',
        address: '',
        City: '',
        State: '',
        Appointment: '',
        Appointment_hr: '',
        Origin: '',
        OrderStatus: 'CREATED',
        Created_dt: new Date().toISOString(),
        D_R: false, // Reset D_R to default value
      });

      setOrderProducts([]);

      const fetchOrders = async () => {
        try {
          const data = await getOrders();
          setOrders(data);
        } catch (error) {
          console.error('Error al obtener las órdenes:', error);
        }
      };

      fetchOrders();
    } catch (error) {
      console.error('Error al crear la orden:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAppointmentRangeChange = (dates) => {
    const [start, end] = dates;
    setFilter((prev) => ({
      ...prev,
      appointmentRange: [start, end],
    }));
  };

  const handleCuentasChange = (event) => {
    const {
      target: { value },
    } = event;
    
    // Si se hace clic en "all"
    if (value.includes('all')) {
      // Toggle: si no están todos seleccionados, seleccionar todos; si todos están seleccionados, deseleccionar todos
      if (filter.cuentas.length !== Cuentas.length) {
        const allClientNames = Cuentas.map(c => c.nombre);
        setFilter(prev => ({
          ...prev,
          cuentas: allClientNames
        }));
      } else {
        setFilter(prev => ({
          ...prev,
          cuentas: []
        }));
      }
    } 
    // Selección normal de clientes individuales
    else {
      setFilter(prev => ({
        ...prev,
        cuentas: typeof value === 'string' ? value.split(',') : value
      }));
    }
  };

  // Reemplazar el handler de filtro de estado por uno específico para multiselector
  const handleStatusesChange = (event) => {
    const {
      target: { value },
    } = event;
    // En caso de "Todos", establecer array vacío
    const selectedStatuses = value.includes('all') ? [] : value;
    setFilter(prev => ({
      ...prev,
      statuses: selectedStatuses
    }));
  };

  // Modificar la función de filtrado para usar useMemo
  const filteredOrders = useMemo(() => {
    return orders
      .filter((order) => {
        const matchesOrderNumber = order.Order_number?.toLowerCase().includes(filter.orderNumber?.toLowerCase() || '') ?? false;
        const matchesCustomer = order.customer?.toLowerCase().includes(filter.customer?.toLowerCase() || '') ?? false;
        const matchesCuenta = filter.cuentas.length === 0 || filter.cuentas.includes(order.cuenta);
        let matchesAppointment = true;
        if (filter.appointmentRange[0] && filter.appointmentRange[1]) {
          if (order.Appointment) {
            const appointmentDateStr = order.Appointment.split('T')[0];
            const [year, month, day] = appointmentDateStr.split('-').map(Number);
            const appointmentDate = new Date(year, month - 1, day);
            const startDate = new Date(
              filter.appointmentRange[0].getFullYear(),
              filter.appointmentRange[0].getMonth(),
              filter.appointmentRange[0].getDate()
            );
            const endDate = new Date(
              filter.appointmentRange[1].getFullYear(),
              filter.appointmentRange[1].getMonth(),
              filter.appointmentRange[1].getDate()
            );
            endDate.setHours(23, 59, 59, 999);
            matchesAppointment = appointmentDate >= startDate && appointmentDate <= endDate;
          } else {
            matchesAppointment = false;
          }
        }
        const matchesStatus = filter.statuses.length === 0 || 
          filter.statuses.includes(order.Order_status);
        return matchesOrderNumber && matchesCustomer && matchesCuenta && matchesAppointment && matchesStatus;
      })
      .sort((a, b) => new Date(b.Created_dt) - new Date(a.Created_dt));
  }, [orders, filter]);

  // Calcular los datos a mostrar en la página actual
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const paginatedOrders = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return filteredOrders.slice(start, end);
  }, [filteredOrders, page, rowsPerPage]);

  // Cambiar de página
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  // Cambiar cantidad de filas por página
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  // Resetear página si cambia el filtro
  useEffect(() => {
    setPage(1);
  }, [filter]);

  useEffect(() => {
    const mideaOrders = orders.filter(o => o.cuenta === 'MIDEA MEXICO');
    console.log('Órdenes con cuenta MIDEA MEXICO:', mideaOrders.length);
    //console.log('Ejemplo de orden de MIDEA:', mideaOrders[0]);

    // Verificar que Cuentas contiene MIDEA MEXICO
    const mideaCuenta = Cuentas.find(c => c.nombre === 'MIDEA MEXICO');
    console.log('Cuenta MIDEA encontrada en Cuentas:', mideaCuenta);
  }, [orders, Cuentas]);

  const stats = {
    totalOrders: orders.length,
    PENDING: orders.filter((order) => order.Order_status === 'PENDIENTE').length,
    ASSIGNED: orders.filter((order) => order.Order_status === 'ASIGNADO').length,
    CREATED: orders.filter((order) => order.Order_status === 'CREADO').length,
    IN_TRANSIT: orders.filter((order) => order.Order_status === 'TRANSITO').length,
    DELIVERED: orders.filter((order) => order.Order_status === 'FINALIZADO').length,
    ON_CLIENT: orders.filter((order) => order.Order_status === 'EN CLIENTE').length,
  };

  const handleCardClick = (status) => {
    // Si la tarjeta ya está activa, desactivarla (quitar el filtro)
    if (activeStatusCard === status) {
      setFilter(prev => ({
        ...prev,
        statuses: []
      }));
      setActiveStatusCard(null);
    } else {
      // Activar la tarjeta y aplicar el filtro correspondiente
      let statusesToFilter = [];
      
      switch (status) {
        case 'TOTAL':
          // No aplicar filtros para mostrar todo
          statusesToFilter = [];
          break;
        case 'FINISHED':
          statusesToFilter = ['FINALIZADO'];
          break;
        case 'IN_PROCESS':
          statusesToFilter = ['PENDIENTE', 'ASIGNADO', 'TRANSITO', 'EN CLIENTE'];
          break;
        case 'PENDING':
          statusesToFilter = ['CREADO'];
          break;
        default:
          statusesToFilter = [];
      }
      
      setFilter(prev => ({
        ...prev,
        statuses: statusesToFilter
      }));
      setActiveStatusCard(status);
    }
  };

  const isOrderInShipment = (order) => {
    return order.shipment_id !== null;
  };

  const toggleOrderExpand = (orderId) => {
    setExpandedOrders(prev => ({
      ...prev,
      [orderId]: !prev[orderId]
    }));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
  };

  const getProductDescription = (productId) => {
    const product = products.find(p => p.id === productId);
    return product ? `${product.codigo_producto} - ${product.descripcion}` : 'Sin descripción';
  };

  const OrderRow = ({ order, actions, formatDate, toggleOrderExpand }) => {
    const isOpen = expandedOrders[order.id] || false;

    return (
      <>
        {/* Fila normal con los datos de la orden */}
        <TableRow className="hover:bg-gray-50">
          <TableCell className="px-2 py-2">
            <div
              className="cursor-pointer flex items-center justify-center"
              onClick={() => toggleOrderExpand(order.id)}
            >
              {isOpen ? (
                <ChevronDown className="h-5 w-5 text-gray-500" />
              ) : (
                <ChevronRight className="h-5 w-5 text-gray-500" />
              )}
            </div>
          </TableCell>
          <TableCell className="px-4 py-2">{order.Order_number}</TableCell>
          <TableCell className="px-4 py-2">{order.customer}</TableCell>
          <TableCell className="px-4 py-2">{order.Order_status}</TableCell>
          <TableCell className="px-4 py-2">{order.Appointment + ' ' + order.Appointment_hr}</TableCell>
          <TableCell className="px-4 py-2">
            <div className="flex items-center gap-2">
              {actions(order)}
            </div>
          </TableCell>
        </TableRow>

        {/* Fila colapsable con los detalles de la orden */}
        {isOpen && (
          <tr className="accordion-row bg-white">
            <td colSpan="6" className="p-0 border-0">
              <div className="w-full bg-white border-t border-gray-200 shadow-inner p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Order Details */}
                  <div className="bg-gray-50 p-4 rounded-lg shadow space-y-3">
                    <h3 className="font-semibold text-lg border-b pb-2 text-gray-700">Detalles de la Orden</h3>
                    <div className="flex items-center">
                      <span><strong>Consignatario:</strong> {order.customer || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <span><strong>Dirección:</strong> {order.address || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <span><strong>Ciudad:</strong> {order.City || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <span><strong>Estado:</strong> {order.State || 'N/A'}</span>
                    </div>
                    <div className="flex items-center">
                      <span><strong>Fecha de Cita:</strong> {order.Appointment ? formatDate(order.Appointment) : 'N/A'}</span>
                    </div>
                  </div>

                  {/* Products Information */}
                  <div className="bg-gray-50 p-4 rounded-lg shadow">
                    <h3 className="font-semibold text-lg border-b pb-2 text-gray-700">Productos ({order.productos?.length || 0})</h3>
                    <div className="mt-2 max-h-40 overflow-y-auto">
                      {order.productos && order.productos.length > 0 ? (
                        <ul className="space-y-2">
                          {order.productos.map((product) => (
                            <li key={product.product_id} className="border-b pb-1">
                              <div className="flex justify-between">
                                <span className="font-medium">{getProductDescription(product.product_id)}</span>
                                <span className="text-sm text-gray-600">Cantidad: {product.product_qt}</span>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-gray-500 italic">Sin productos asignados</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        )}
      </>
    );
  };

  // Create a function to render actions for each row
  const renderActions = (order) => {
    // Determinar si la orden se puede editar basado en su estado
    const isEditable = order.Order_status === 'CREADO' || order.Order_status === 'PENDIENTE';
    
    return (
    <div className="flex items-center space-x-2">
      <Button 
        onClick={() => handleEdit(order.id)} 
        className={`mr-2 ${!isEditable ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={!isEditable}
        title={!isEditable ? "Solo se pueden editar órdenes en estado CREADO o PENDIENTE" : "Editar orden"}
      >
        <Edit className={!isEditable ? "text-gray-400" : ""} />
      </Button>
      <Button
        className={`hover:bg-gray-400 rounded-lg text-gray-800 ${isOrderInShipment(order) ? 'opacity-50 cursor-not-allowed' : ''}`}
        onClick={() => confirmDeleteOrder(order.id)}
        disabled={isOrderInShipment(order)}
        title={isOrderInShipment(order) ? "No se puede eliminar una orden asignada a un envío" : "Eliminar orden"}
      >
        <Trash className={isOrderInShipment(order) ? "text-gray-400" : ""} />
      </Button>
    </div>
  );
  }

  // Función para alternar la visibilidad del calendario
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  // Agregar un botón de reset para el filtro de fecha
  const clearDateFilter = () => {
    setFilter(prev => ({
      ...prev,
      appointmentRange: [null, null]
    }));
    setIsCalendarOpen(false);
  };

  // Create a proper cleanup function for the edit modal
  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    
    // Reset edit form data
    setEditFormData({});
    
    // Reset order products
    setOrderProducts([]);
    
    // Reset selected client locations
    setSelectedClientLocations([]);
    
    // Reset selected client
    setSelectedClient(null);
  };

  // Función para exportar órdenes a Excel
  const exportToExcel = () => {
    try {
      // Obtener solo las órdenes filtradas actualmente
      const ordersToExport = filteredOrders.map(order => ({
        'Número de orden': order.Order_number || '',
        'Cliente': order.cuenta || '',
        'Consignatario': order.customer || '',
        'Dirección': order.address || '',
        'Ciudad': order.City || '',
        'Estado': order.State || '',
        'Fecha de cita': order.Appointment ? new Date(order.Appointment).toLocaleDateString('es-ES') : '',
        'Hora de cita': order.Appointment_hr || '',
        'Estado': order.Order_status || '',
        'Origen': order.Origin || '',
        'Fecha de creación': order.Created_dt ? formatDate(order.Created_dt) : ''
      }));

      // Crear un nuevo libro Excel
      const worksheet = XLSX.utils.json_to_sheet(ordersToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Órdenes");

      // Establecer anchos de columna
      const columnsWidth = [
        { wch: 15 }, // Número de orden
        { wch: 20 }, // Cliente
        { wch: 20 }, // Consignatario
        { wch: 30 }, // Dirección
        { wch: 15 }, // Ciudad
        { wch: 15 }, // Estado
        { wch: 15 }, // Fecha de cita
        { wch: 15 }, // Hora de cita
        { wch: 15 }, // Estado
        { wch: 15 }, // Origen
        { wch: 20 }, // Fecha de creación
      ];
      worksheet['!cols'] = columnsWidth;

      // Generar el archivo Excel para descargar con timestamp para evitar nombre duplicado
      const timestamp = new Date().toISOString().replace(/[-:\.]/g, "").substring(0, 14);
      XLSX.writeFile(workbook, `Ordenes_${timestamp}.xlsx`);
      
      toast.success('Órdenes exportadas a Excel correctamente');
    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      toast.error('Error al exportar órdenes a Excel');
    }
  };

  return (
    <div className="flex">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        onLogout={handleLogout}
      />

      {/* Contenido principal */}
      <div
        className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6`}
      >
        {/* Topbar component */}
        <Topbar 
          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />

        {/* Button to Create New Order at the top */}
        <div className="my-4">
          <Button
            onClick={() => setIsModalNewOrderOpen(true)}
            className="p-2 bg-sky-700 text-white rounded-lg hover:bg-sky-800 flex items-center gap-2"
          >
            <Plus className="h-5 w-5" />
            <span className="font-medium">Crear Orden</span>
          </Button>

          
        </div>

        {/* Loading and Error state handling */}
        {loading ? (
          <div className="bg-white rounded-xl shadow-md p-8 text-center my-6">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
            <p className="mt-4 text-gray-600">Cargando información de órdenes...</p>
          </div>
        ) : error ? (
          <div className="bg-white rounded-xl shadow-md p-8 text-center my-6">
            <div className="flex justify-center">
              <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <p className="mt-4 text-gray-600">Error al cargar las órdenes: {error.message}</p>
            <button 
              onClick={fetchOrders}
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Reintentar
            </button>
          </div>
        ) : (
          <>
            {/* Filter Bar */}
            <Stack direction="row" spacing={2} sx={{ mb: 3, mt: 3, flexWrap: 'wrap', gap: 1 }}>
              {/* Filtro por número de orden */}
              <FormControl sx={{ minWidth: 180 }} size="small">
                <TextField
                  label="Número de orden"
                  name="orderNumber"
                  value={filter.orderNumber}
                  onChange={handleFilterChange}
                  size="small"
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                    }
                  }}
                />
              </FormControl>

              {/* Reemplazar el filtro de fecha única por un rango */}
              <div className="filter-container" style={{ minWidth: 180, position: 'relative' }}>
                <div className="flex items-center border rounded-md bg-white">
                  <input
                    type="text"
                    className="p-2 flex-grow rounded-l-md outline-none"
                    placeholder="Rango de fecha de cita"
                    value={
                      filter.appointmentRange[0] && filter.appointmentRange[1]
                        ? `${filter.appointmentRange[0].toLocaleDateString()} - ${filter.appointmentRange[1].toLocaleDateString()}`
                        : filter.appointmentRange[0]
                        ? `${filter.appointmentRange[0].toLocaleDateString()} - ...`
                        : ""
                    }
                    onClick={toggleCalendar}
                    readOnly
                  />
                  {(filter.appointmentRange[0] || filter.appointmentRange[1]) && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        clearDateFilter();
                      }}
                      className="px-2 text-gray-400 hover:text-gray-600"
                      title="Borrar filtro de fecha"
                    >
                      ✕
                    </button>
                  )}
                </div>
                {isCalendarOpen && (
                  <div 
                    style={{ 
                      position: 'absolute', 
                      left: 0, 
                      top: '100%', 
                      zIndex: 9999, 
                      backgroundColor: 'white',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                      borderRadius: '0.375rem',
                      marginTop: '0.25rem',
                      padding: '0.5rem'
                    }}
                  >
                    <DatePicker
                      selected={filter.appointmentRange[0]}
                      onChange={handleAppointmentRangeChange}
                      startDate={filter.appointmentRange[0]}
                      endDate={filter.appointmentRange[1]}
                      selectsRange
                      inline
                      dateFormat="dd/MM/yyyy"
                      onClickOutside={toggleCalendar}
                    />
                  </div>
                )}
              </div>

              {/* Filtro por consignatario */}
              <FormControl sx={{ minWidth: 180 }} size="small">
                <TextField
                  label="Consignatario"
                  name="customer"
                  value={filter.customer}
                  onChange={handleFilterChange}
                  size="small"
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: 'white',
                    }
                  }}
                />
              </FormControl>
              
              {/* Filtro por clientes (multiselect) */}
              <FormControl sx={{ width: 220 }} size="small">
                <InputLabel id="cuenta-select-label">Cliente(s)</InputLabel>
                <Select
                  labelId="cuenta-select-label"
                  id="cuenta-select"
                  multiple
                  value={filter.cuentas}
                  onChange={handleCuentasChange}
                  input={<OutlinedInput label="Cliente(s)" />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return "Todos los clientes";
                    }
                    return selected.length === 1 
                      ? selected[0]
                      : `${selected.length} clientes seleccionados`;
                  }}
                  sx={{
                    backgroundColor: 'white',
                    '& .MuiSelect-select': {
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox 
                      checked={filter.cuentas.length === Cuentas.length}
                      indeterminate={filter.cuentas.length > 0 && filter.cuentas.length < Cuentas.length} 
                    />
                    <ListItemText primary={filter.cuentas.length === Cuentas.length ? "Deseleccionar todos" : "Seleccionar todos"} />
                  </MenuItem>
                  {Cuentas.map((cuenta) => (
                    <MenuItem key={cuenta.id} value={cuenta.nombre}>
                      <Checkbox checked={filter.cuentas.includes(cuenta.nombre)} />
                      <ListItemText primary={cuenta.nombre} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              
              {/* Reemplazar el filtro de estado simple por un multiselector */}
              <FormControl sx={{ minWidth: 180 }} size="small">
                <InputLabel id="status-select-label">Estado(s)</InputLabel>
                <Select
                  labelId="status-select-label"
                  id="status-select"
                  multiple
                  value={filter.statuses}
                  onChange={handleStatusesChange}
                  input={<OutlinedInput label="Estado(s)" />}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return "Todos los estados";
                    }
                    return selected.join(', ');
                  }}
                  sx={{
                    backgroundColor: 'white',
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  <MenuItem value="all">
                    <Checkbox 
                      checked={filter.statuses.length === 0}
                      indeterminate={filter.statuses.length > 0 && filter.statuses.length < orderStatuses.length} 
                    />
                    <ListItemText primary="Todos los estados" />
                  </MenuItem>
                  {orderStatuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      <Checkbox checked={filter.statuses.includes(status)} />
                      <ListItemText primary={status} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            {/* Cards */}
            <div className="mb-6 grid gap-6 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4">
              <div 
                onClick={() => handleCardClick('TOTAL')}
                className={`shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 ${
                  activeStatusCard === 'TOTAL' 
                    ? 'bg-blue-100 border-blue-500' 
                    : 'border-transparent hover:border-gray-300'
                }`}
              >
                <Card>
                  <CardHeader className="flex flex-row items-center space-y-0">
                    <CardTitle className="text-sm font-medium">Órdenes Totales</CardTitle>
                    <Package className={`ml-auto h-6 w-6 ${activeStatusCard === 'TOTAL' ? 'text-blue-500' : 'text-muted-foreground'}`} />
                  </CardHeader>
                  <CardContent>
                    <div className="text-3xl font-semibold text-gray-900">{stats.totalOrders}</div>
                  </CardContent>
                </Card>
              </div>

              <div 
                onClick={() => handleCardClick('FINISHED')}
                className={`shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 ${
                  activeStatusCard === 'FINISHED' 
                    ? 'bg-green-100 border-green-500' 
                    : 'border-transparent hover:border-gray-300'
                }`}
              >
                <Card>
                  <CardHeader className="flex flex-row items-center space-y-0">
                    <CardTitle className="text-sm font-medium">Órdenes Finalizadas</CardTitle>
                    <Package className={`ml-auto h-6 w-6 ${activeStatusCard === 'FINISHED' ? 'text-green-500' : 'text-muted-foreground'}`} />
                  </CardHeader>
                  <CardContent>
                    <div className="text-3xl font-semibold text-gray-900">{stats.DELIVERED}</div>
                  </CardContent>
                </Card>
              </div>
              
              <div 
                onClick={() => handleCardClick('IN_PROCESS')}
                className={`shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 ${
                  activeStatusCard === 'IN_PROCESS' 
                    ? 'bg-amber-100 border-amber-500' 
                    : 'border-transparent hover:border-gray-300'
                }`}
              >
                <Card>
                  <CardHeader className="flex flex-row items-center space-y-0">
                    <CardTitle className="text-sm font-medium">Órdenes en Proceso</CardTitle>
                    <Truck className={`ml-auto h-6 w-6 ${activeStatusCard === 'IN_PROCESS' ? 'text-amber-500' : 'text-muted-foreground'}`} />
                  </CardHeader>
                  <CardContent>
                    <div className="text-3xl font-semibold text-gray-900">{stats.ASSIGNED + stats.IN_TRANSIT + stats.ON_CLIENT + stats.PENDING}</div>
                  </CardContent>
                </Card>
              </div>

              <div 
                onClick={() => handleCardClick('PENDING')}
                className={`shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer border-2 ${
                  activeStatusCard === 'PENDING' 
                    ? 'bg-red-100 border-red-500' 
                    : 'border-transparent hover:border-gray-300'
                }`}
              >
                <Card>
                  <CardHeader className="flex flex-row items-center space-y-0">
                    <CardTitle className="text-sm font-medium">Órdenes Pendientes</CardTitle>
                    <Truck className={`ml-auto h-6 w-6 ${activeStatusCard === 'PENDING' ? 'text-red-500' : 'text-muted-foreground'}`} />
                  </CardHeader>
                  <CardContent>
                    <div className="text-3xl font-semibold text-gray-900">{stats.CREATED}</div>
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Orders Table */}
            <Card className="shadow-lg">
              <CardHeader className="bg-gray-800 text-white">
                <CardTitle>Órdenes Recientes</CardTitle>
              </CardHeader>
              <CardContent className="bg-white p-0">
                <div className="relative">
                  <div className="sticky top-0 z-10 bg-gray-200">
                    <Table className="table-fixed w-full">
                      <TableHeader>
                        <TableRow>
                          <TableHead className="w-1/5 px-4 py-4">
                            <div className="ml-16">Numero de orden</div>
                          </TableHead>
                          <TableHead className="w-1/5 px-4 py-4">
                            <div className="ml-12 mr-6">Consignatario</div>
                          </TableHead>
                          <TableHead className="w-1/5 px-4 py-4">
                            <div className="ml-6 mr-0 ">Estado</div>
                          </TableHead>
                          <TableHead className="w-1/5 px-4 py-4">
                            <div className="ml-0 mr-0">Fecha de Cita</div>
                          </TableHead>
                          <TableHead className="w-1/5 px-4 py-4">
                            <div className="ml-0">Acciones</div>
                          </TableHead>
                        </TableRow>
                      </TableHeader>
                    </Table>
                  </div>
                  <div className="overflow-y-auto max-h-96">
                    <Table className="table-auto w-full">
                      <TableBody>
                        {paginatedOrders.map((order) => (
                          <OrderRow
                            key={order.id}
                            order={order}
                            actions={renderActions}
                            formatDate={formatDate}
                            toggleOrderExpand={toggleOrderExpand}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </div>
                {/* Controles de paginación */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="rows-per-page-label">Filas por página</InputLabel>
                    <Select
                      labelId="rows-per-page-label"
                      value={rowsPerPage}
                      label="Filas por página"
                      onChange={handleChangeRowsPerPage}
                    >
                      {[10, 20, 50, 100].map((rows) => (
                        <MenuItem key={rows} value={rows}>{rows}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Pagination
                    count={Math.ceil(filteredOrders.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                    color="primary"
                    shape="rounded"
                  />
                  <span style={{ fontSize: 14 }}>
                    Mostrando {filteredOrders.length === 0 ? 0 : (page - 1) * rowsPerPage + 1}
                    -{Math.min(page * rowsPerPage, filteredOrders.length)} de {filteredOrders.length}
                  </span>
                </div>
              </CardContent>
            </Card>
          </>
        )}

        {/* Modals - outside the loading conditional since they don't depend on orders data */}
        <NewOrderModal
          isOpen={isModalNewOrderOpen}
          onClose={() => setIsModalNewOrderOpen(false)}
          formData={formData}
          handleFormChange={handleFormChange}
          handleCreateOrder={handleCreateOrder}
          clients={clients}
          selectedClientLocations={selectedClientLocations}
          handleClientChange={handleClientChange}
          handleLocationChange={handleLocationChange}
          bodegas={bodegas}
          handleBodegaChange={handleBodegaChange}
          selectedwarehouseLocations={selectedwarehouseLocations}
          orderProducts={orderProducts}
          products={products}
          handleProductChange={handleProductChange}
          handleAddProduct={handleAddProduct}
          handleRemoveProduct={handleRemoveProduct}
          Cuentas={Cuentas}
          handleCuentaChange={handleCuentaChange}
        />

        <EditOrderModal
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          formData={editFormData}
          handleFormChange={handleEditChange}
          handleSubmit={handleEditSubmit}
          clients={clients}
          selectedClientLocations={selectedClientLocations}
          handleClientChange={handleClientChange}
          handleLocationChange={handleLocationChange}
          bodegas={bodegas}
          handleBodegaChange={handleBodegaChange}
          products={products}
          handleProductChange={handleProductChange}
          handleAddProduct={handleAddProduct}
          orderProducts={orderProducts}
          handleRemoveProduct={handleRemoveProduct}
          Cuentas={Cuentas}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default Orders;